<template>
  <v-app id="reset">
    <v-main class="background-login">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <logo />
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card class="rounded-xl" color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5">¿Olviaste tu contraseña?</v-card-title>
                    <v-card-text>Ingresa tu usuario y te enviaremos un correo con las instrucciones para reestablecer tu contraseña.</v-card-text>
                    <v-card-text>
                      <v-text-field
                        v-model="user"
                        type="text"
                        :disabled="flag || loading"
                        prepend-icon="mdi-account"
                        required
                        autocomplete="off"
                        label="Usuario"
                        @input="$v.user.$touch()"
                        @blur="$v.user.$touch()"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :disabled="loading" @click="home()">Volver</v-btn>
                      <v-btn type="submit" text :disabled="flag" :loading="loading">Enviar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ errorList[codeError] }}
                </v-snackbar>
                <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
                  {{ msgSuccess }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <main-footer />
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import services from "@/utils/services";
import logo from "@/components/Logo";
import mainFooter from "@/components/Footer";
import errorList from "@/utils/errorsList";

export default {
  name: "recovery",
  components: { logo, mainFooter },
  mixins: [validationMixin],
  validations: {
    user: {
      required,
      email,
      //maxLength: maxLength(50)
    },
  },
  data: () => ({
    loading: false,
    error: false,
    msgError: "",
    success: false,
    msgSuccess: "",
    solicitud: "",
    user: "",
    flag: false,
    errorList,
  }),
  mounted() {
    //this.solicitud = this.$route.query.id
  },
  computed: {
    userErrors() {
      const errors = [];
      if (!this.$v.user.$dirty) return errors;
      !this.$v.user.required && errors.push("El campo es obligatorio");
      !this.$v.user.email && errors.push("El campo excede la longitud máxima");
      return errors;
    },
  },
  methods: {
    clear() {
      this.$v.$reset();
      this.user = "";
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid && this.user != null) {
        this.recovery();
      } else if (this.user == null || this.user == "") {
        this.error = true;
        this.msgError = "Introduzaca el nombre de usuario";
      } else {
        this.error = true;
        this.msgError = "Algunos datos del formulario son incorrectos";
      }
    },
    home() {
      this.$router.push("/login");
    },
    recovery() {
      let data = {
        data: {
          email: this.user,
          es_externo: true,
          es_movil: false,
        },
      };
      this.loading = true;
      setTimeout(() => {
        this.axios
          .post(services.routes.recoveryPass, data)
          .then(() => {
            this.clear();
            this.success = true;
            this.msgSuccess = "Código de verificacion enviado al correo electronico";
          })
          .catch(() => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
  },
};
</script>

<style scoped>
.background-login {
  background-color: white !important;
}
</style>
